
import { mapGetters } from 'vuex'

import Currency from '~/mixins/Currency.js'
import ProductNumber from '~/mixins/ProductNumber.js'

export default {
  mixins: [Currency, ProductNumber],

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('cart', ['cart']),

    productPrice() {
      return this.$auth.$state.priceInclTax
        ? this.product.gross_price
        : this.product.price
    },

    onlyBusiness() {
      const businessProduct = this.product.is_business

      const privateCustomer = this.$auth.$state.user?.customerType === 'private'

      return businessProduct && privateCustomer
    },
  },

  methods: {
    async addToCart() {
      if (!this.cart.items) {
        await this.$store.dispatch('cart/getCart')
      }

      await this.$store.dispatch('cart/incrementQuantity', this.product.id)
    },
  },
}
